<template>
  <div class="tw-text-center tw-py-8 tw-px-4">
    <!-- Icon -->
    <div class="tw-mb-4">
      <div class="tw-w-16 tw-h-16 tw-mx-auto tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center">
        <icon :icon="getEmptyStateIcon(category)" class="tw-text-2xl tw-text-gray-400" />
      </div>
    </div>

    <!-- Title -->
    <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-2">
      {{ getEmptyStateTitle(category) }}
    </h3>

    <!-- Description -->
    <p class="tw-text-sm tw-text-gray-600 tw-mb-6 tw-max-w-md tw-mx-auto">
      {{ getEmptyStateDescription(category) }}
    </p>

    <!-- Action Button (if provided) -->
    <div v-if="actionText && actionHandler" class="tw-flex tw-justify-center">
      <a-button 
        @click="handleAction"
        intent="primary"
        size="sm"
      >
        <icon :icon="getActionIcon(category)" class="tw-mr-1" />
        {{ actionText }}
      </a-button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  category: {
    type: String,
    required: true,
    validator: (value) => ['today', 'upcoming', 'past'].includes(value)
  },
  actionText: {
    type: String,
    default: ''
  },
  actionHandler: {
    type: Function,
    default: null
  }
})

const emit = defineEmits(['action'])

// Helper functions
const getEmptyStateIcon = (category) => {
  const icons = {
    today: 'solar:calendar-bold-duotone',
    upcoming: 'solar:clock-circle-bold-duotone',
    past: 'solar:history-bold-duotone'
  }
  return icons[category] || 'solar:calendar-bold-duotone'
}

const getEmptyStateTitle = (category) => {
  const titles = {
    today: 'No Events Today',
    upcoming: 'No Upcoming Events',
    past: 'No Past Events'
  }
  return titles[category] || 'No Events'
}

const getEmptyStateDescription = (category) => {
  const descriptions = {
    today: 'There are no events scheduled for today. Check back later or browse upcoming events.',
    upcoming: 'No upcoming events found. New events will appear here once they are scheduled.',
    past: 'No past events to display. Completed events will appear here.'
  }
  return descriptions[category] || 'No events found.'
}

const getActionIcon = (category) => {
  const icons = {
    today: 'solar:calendar-add-bold',
    upcoming: 'solar:calendar-add-bold',
    past: 'solar:history-bold'
  }
  return icons[category] || 'solar:calendar-bold'
}

const handleAction = () => {
  if (props.actionHandler) {
    props.actionHandler()
  } else {
    emit('action', props.category)
  }
}
</script> 